<template>
  <div
    :class="`message-container ${
      theme.isDark ? 'message-container_dark' : null
    }`"
    v-if="messages.length !== 0"
    ref="messageContainer"
    @scroll="scrollContainer()"
  >
    <Texts
        ref="texts"
        v-bind:class="{ unread: !message.read_status }"
        v-bind:id="message.id"
        v-for="message in messages"
        :message="message"
        :key="message.id"
    />
  </div>
  <div
    v-else
    :class="[
        'message-container message-container_empty',
        `${theme.isDark ? 'message-container_dark' : ''}`
    ]"
  >
    <p>No Messages</p>
  </div>
</template>

<script>
import Texts from "@/components/messages/text/Texts";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TextContainer",
  inject: ["theme"],
  props: {
    messages: Array,
  },
  components: {
    Texts,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    })
  },
  methods: {
    ...mapActions({
      updateMessageNotification: "notifications/updateMessageNotification",
    }),
    scrollContainer() {
      if (this.user.role_id !== 1) {
        const container = this.$refs.messageContainer;
        const containerBottomPos = container.offsetHeight + container.offsetTop * 2;
        const texts = this.$refs.texts;
        let textTop = 0;

        texts.forEach(text => {
          if (text.$el.classList.contains("unread")) {
            textTop = text.$el.getBoundingClientRect().top;
            if (textTop < containerBottomPos) {
              text.$el.classList.remove("unread");
              this.updateMessageNotification(parseInt(text.$el.id));
            }
          }
        });
      }
    }
  },
  mounted() {
    this.scrollContainer();
  }
};
</script>

<style>
  .message {
    position: relative;
  }
  .message:before {
    content: "";
    width: 20px;
    height: 15px;
    background-image: url("../../../../public/icons/check-solid.svg");
    position: absolute;
    top: 37px;
    right: 7px;
    opacity: 1;
    transition: all .7s ease;
  }
  .unread:before {
    opacity: 0;
  }
</style>